module.exports = __webpack_public_path__ + "media/images/symbols/phone-8aab884ddb3121407ec85236d1874ff1.svg";